function ProductViewCarouselPhotosCtrl() {
  var ctrl = this;

  ctrl.carouselInit = function (carousel) {
    ctrl.carousel = carousel;
  };
}

;
export default ProductViewCarouselPhotosCtrl;